<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>배송요금</h3>
				<h4>배송요금은 어떻게 책정되나요?</h4>
			</div>
			


			<!-- <ul class="set-fee-list mb100">
				<li>고로켓고의 배송요금에는 국내의 배송지까지의 국제 배송료와 국내 배송료가 포함되어 있습니다.</li>
				<li>신청하신 유료옵션이 있을 경우 배송요금에 추가됩니다.</li>
				<li>
					부피, 무게에 따른 CJ대한통운 할증 비용 발생할 수 있습니다.
		
				</li>
				<li>
					또한, 포장 후 무게 20kg이상 또는 부피(가로+세로+높이)가 160cm를 넘는 경우, 한 변의 길이가 100cm 이상이거나 이형화물, 마대포장, 포장불량으로 <br>상품파손이 염려되는 경우, 규격박스가 아닌 경우 등의 화물은 화물택배 (경동택배 또는 대신택배) 로 진행되어 추가 운임 발생합니다.                
					<br />
					<span class="link-btn" @click="onUrl('https://kdexp.com/service/charge/package_standard.do')">
						경동택배 추가운임 보기 <i class="el-icon-top-right"></i>
					</span>
		
				</li>
				<li>세관에서 개인 사용 물품으로 볼 수 없거나, 목록통관 배제물품, 미화150불 이상 등 과세대상일 경우 일반(간이) 통관으로 진행되어 관부가세 및 창고료가 추가 발생 할 수 있습니다.</li>
				<li>관련 법령근거 운송불가 물품 및 검역 등의 필요한 물품을 운송 지시하여 발생한 모든 불이익은 고로켓고에서 책임지지 않으며 폐기, 반송, 검역, 분할 등에 따른 비용이 청구 될 수 있습니다.</li>
				<li>제주, 도서산간 지역은 추가운임 발생됩니다.</li>
				<li>배송비는 부피와 무게를 고려하여 책정합니다. 무게가 가볍더라도 부피가 큰 경우 추가 요금이 책정될 수 있습니다.</li>
				<li>중국  &gt; 한국 배송시 배송요금의 계산 기준은 최소 1kg이며 국제운송요율 기준에 따라 소수점 이하는 절상합니다. (2.3kg &gt; 2.5kg)</li>
			</ul>
			
			<div class="delivery-price-title">배송 요금표</div>
			<div style="display: flex;justify-content: flex-end;">
				<el-select v-model="transport_value" @change="changeSelect" style="margin: 0 0 20px 0;width:100px; " placeholder="请选择">
				   <el-option
				     v-for="item in options"
				     :key="item.value"
				     :label="item.label"
				     :value="item.value">
				   </el-option>
				 </el-select>
			</div>
	
			   <el-table
				:data="tableData" border
				style="width: 100%">
				<el-table-column label="실제 무게(kg)">
					<el-table-column
					  prop="weight"
					  label="이용건수"
					  >
					</el-table-column>
				</el-table-column>
				<el-table-column label="개인 일반 회원">
					<el-table-column
					  prop="personal_member"
					  label="0~99 건"
					  >
					</el-table-column>
				</el-table-column>	
				<el-table-column label="개인 파트너 회원">
					<el-table-column
					  prop="personal_cooperate"
					  label="100 건 ~"
					  >
					</el-table-column>
				</el-table-column>		
				<el-table-column label="사업자 일반 회원">
					<el-table-column
					  prop="business_member"
					  label="0~499 건">
					</el-table-column>
				</el-table-column>		
				<el-table-column label="사업자 파트너 회원">	
					<el-table-column
					  prop="business_cooperate"
					  label="500 건 ~">
					</el-table-column>
				</el-table-column>	
				
			  </el-table>
			  
			  <div style="text-align: center;" >
			  	<router-link to="/agencyShipping" class="register-button">
			  		배송대행 신청
			  	</router-link>
			  </div> -->
			
		</div>
		<div class="calculator-area ">
			<h3 class=""><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">견적계산기</font></font></h3>
			<p class="" style="margin:20px 0 40px 0;"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">자세한 수치를 입력해 나의 배송비를 정확하게 알아보세요.</font></font></p>
			<a href="javascript:void(0);" @click.prevent="showCalculator = true" class="common-link-btn event-common-click-popup" data-width="900" data-height="600"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">포스트팀 견적계산기            </font></font><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M4.64689 1.64592C4.69334 1.59935 4.74851 1.56241 4.80926 1.5372C4.87001 1.512 4.93513 1.49902 5.00089 1.49902C5.06666 1.49902 5.13178 1.512 5.19253 1.5372C5.25327 1.56241 5.30845 1.59935 5.35489 1.64592L11.3549 7.64592C11.4015 7.69236 11.4384 7.74754 11.4636 7.80828C11.4888 7.86903 11.5018 7.93415 11.5018 7.99992C11.5018 8.06568 11.4888 8.13081 11.4636 8.19155C11.4384 8.2523 11.4015 8.30747 11.3549 8.35392L5.35489 14.3539C5.26101 14.4478 5.13367 14.5005 5.00089 14.5005C4.86812 14.5005 4.74078 14.4478 4.64689 14.3539C4.55301 14.26 4.50026 14.1327 4.50026 13.9999C4.50026 13.8671 4.55301 13.7398 4.64689 13.6459L10.2939 7.99992L4.64689 2.35392C4.60033 2.30747 4.56339 2.2523 4.53818 2.19155C4.51297 2.13081 4.5 2.06568 4.5 1.99992C4.5 1.93415 4.51297 1.86903 4.53818 1.80828C4.56339 1.74754 4.60033 1.69236 4.64689 1.64592Z" fill="#0B6CFF"></path>
				</svg>
			</a>
		</div>
		
		<CalculatorModal v-model="showCalculator" />
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	import CalculatorModal from '@/components/CalculatorModal.vue'
	import { safePush } from '@/utils/router';
	export default {
		components: {
			PersonalBanner,
			CalculatorModal
		},
		data() {
			return{
				showCalculator: false,
				options: [{
				  value: 1,
				  label: '해운'
				}, {
				  value: 2,
				  label: '항공'
				}],
				transport_value: 1,
				tableData: [{
					weight:1,
					personal_member: '6,900',
					personal_cooperate: '6,600',
					business_member: '5,900',
					business_cooperate:'5,600',
				  }, {
					weight:1.5,
					personal_member: '7,900',
					personal_cooperate: '7,500',
					business_member: '6,800',
					business_cooperate:'6,400',
				  }, {
					weight:2,
					personal_member: '8,900',
					personal_cooperate: '8,400',
					business_member: '7,700',
					business_cooperate:'7,200',
				  }, {
					weight:2.5,
					personal_member: '9,900',
					personal_cooperate: '9,300',
					business_member: '8,600',
					business_cooperate:'8,000',
				  }, {
					weight:3,
					personal_member: '10,900',
					personal_cooperate: '10,200',
					business_member: '9,500',
					business_cooperate:'8,800',
				  }, {
					weight:3.5,
					personal_member: '11,900',
					personal_cooperate: '11,100',
					business_member: '10,400',
					business_cooperate:'9,600',
				  }, {
					weight:4,
					personal_member: '12,900',
					personal_cooperate: '12,000',
					business_member: '11,300',
					business_cooperate:'10,400',
				  }, {
					weight:4.5,
					personal_member: '13,900',
					personal_cooperate: '12,900',
					business_member: '12,200',
					business_cooperate:'11,200',
				  }, {
					weight:5,
					personal_member: '14,900',
					personal_cooperate: '13,800',
					business_member: '13,100',
					business_cooperate:'12,000',
				  }]
				  
				  
				
			}
		},
		methods: {
			onNav(url){
				const { href } = this.$router.resolve({ path: url });
				window.open(href, '_blank');
			},
			onUrl(url){
				window.open(url, '_blank');
			},
			onCurrentNav(url){
				safePush(this.$router, url);
			},
			changeSelect(value){
				console.log(value)
				if(value==2){
					this.tableData=[{
						weight:1,
						personal_member: '8,300',
						personal_cooperate: '7,900',
						business_member: '7,600',
						business_cooperate:'7,300',
						}, {
						weight:1.5,
						personal_member: '10,100',
						personal_cooperate: '9,700',
						business_member: '9,200',
						business_cooperate:'8,900',
						}, {
						weight:2,
						personal_member: '11,900',
						personal_cooperate: '11,500',
						business_member: '10,800',
						business_cooperate:'10,500',
						}, {
						weight:2.5,
						personal_member: '13,700',
						personal_cooperate: '13,300',
						business_member: '12,400',
						business_cooperate:'12,100',
						}, {
						weight:3,
						personal_member: '15,500',
						personal_cooperate: '15,100',
						business_member: '14,000',
						business_cooperate:'13,700',
						}, {
						weight:3.5,
						personal_member: '17,300',
						personal_cooperate: '16,900',
						business_member: '15,600',
						business_cooperate:'15,300',
						}, {
						weight:4,
						personal_member: '19,100',
						personal_cooperate: '18,700',
						business_member: '17,200',
						business_cooperate:'16,900',
						}, {
						weight:4.5,
						personal_member: '20,900',
						personal_cooperate: '20,500',
						business_member: '18,800',
						business_cooperate:'18,500',
						}, {
						weight:5,
						personal_member: '22,700',
						personal_cooperate: '22,300',
						business_member: '20,400',
						business_cooperate:'20,100',
				    }]
				}else if(value==1){
					this.tableData=[{
						weight:1,
						personal_member: '6,900',
						personal_cooperate: '6,600',
						business_member: '5,900',
						business_cooperate:'5,600',
					  }, {
						weight:1.5,
						personal_member: '7,900',
						personal_cooperate: '7,500',
						business_member: '6,800',
						business_cooperate:'6,400',
					  }, {
						weight:2,
						personal_member: '8,900',
						personal_cooperate: '8,400',
						business_member: '7,700',
						business_cooperate:'7,200',
					  }, {
						weight:2.5,
						personal_member: '9,900',
						personal_cooperate: '9,300',
						business_member: '8,600',
						business_cooperate:'8,000',
					  }, {
						weight:3,
						personal_member: '10,900',
						personal_cooperate: '10,200',
						business_member: '9,500',
						business_cooperate:'8,800',
					  }, {
						weight:3.5,
						personal_member: '11,900',
						personal_cooperate: '11,100',
						business_member: '10,400',
						business_cooperate:'9,600',
					  }, {
						weight:4,
						personal_member: '12,900',
						personal_cooperate: '12,000',
						business_member: '11,300',
						business_cooperate:'10,400',
					  }, {
						weight:4.5,
						personal_member: '13,900',
						personal_cooperate: '12,900',
						business_member: '12,200',
						business_cooperate:'11,200',
					  }, {
						weight:5,
						personal_member: '14,900',
						personal_cooperate: '13,800',
						business_member: '13,100',
						business_cooperate:'12,000',
				  }]
				}
				
				
			}
		}
	}
	
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.set-fee-list{
		margin: 0;
		padding: 0;
		list-style: none;
	}
	.set-fee-list li{
		padding-left: 36px;
		font-size: 15px;
		line-height: 34px;
		color: #4E5968;
		background: url('../../assets/icon/ico_set_fee.png') no-repeat 0 5px;
	}
	.link-btn{
		border-radius: 20px;
		margin-left: 5px;
		padding: 5px;
		font-weight: 600;
		font-size: 12px;
		line-height: 18px;
		background: #F4F8FF;
		filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
		border: none;
		color: var(--main-color);
		cursor: pointer;
	}
	.link-btn:hover {
	    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
	}
	.delivery-price-title{
		text-align: center;
		font-weight: 700;
		font-size: 24px;
		line-height: 29px;
		color: #111111;
		margin:50px 0 35px;
	}
	.register-button{
		margin-top: 40px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		min-width: 180px;
		margin-bottom: 40px;
		height: 64px;
		border: 1px solid var(--main-color);
		background: var(--main-color);
		border-radius: 36px;
		font-weight: 500;
		font-size: 17px;
		text-decoration: none !important;
		color: #fff !important;
		transition: 0.25s;
		cursor: pointer;
	}
	.calculator-area {
		background: url(../../assets/list/banner_cal.jpg) no-repeat center / cover;
		text-align: center;
		padding: 92px 0 93px;
		color:#FFF;
		margin-bottom: 150px;
	}
	.calculator-area .common-link-btn {
		border: none;
		background: #FFFFFF;
		font-weight: 700;
		font-size: 16px;
		color: #0b6cff !important; ; /* var(--secondary-color) !important; */
		height: 48px;
		padding: 0 30px;
	}
	.common-link-btn {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		min-width: 180px;
		padding: 0 34px;
		height: 64px;
		border: 1px solid var(--main-color);
		background: var(--main-color);
		border-radius: 36px;
		font-weight: 500;
		font-size: 17px;
		text-decoration: none !important;
		color: #fff !important;
		transition: 0.25s;
		}

	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:10px;
		}
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		
		
	}
	
</style>